module.exports = __webpack_public_path__ + "img/portfolio-guide-modal-illustration-fr7.158ed25.png";